import {gh} from "../../general/general-helpers";

if (document.getElementById('opp-number-1')) {

        const options = {
            color: '#E44F41',
            path: 'straight',
            size: 5,
            endPlug: 'behind',
            startSocket: 'bottom',
            endSocket: 'top',
        }

    gh.doOnEvent( {
        load: null,
        orientationchange: null, // on window orientationchange (for older browsers)
    }, () => {
        if (gh.isDesktopDesign) {
            new LeaderLine(
                LeaderLine.pointAnchor(document.getElementById('opp-number-1'), {x: 45, y: -25}),
                LeaderLine.pointAnchor(document.getElementById('opp-number-2'), {x: 60, y: -40}),
                options
            );

            new LeaderLine(
                LeaderLine.pointAnchor(document.getElementById('opp-number-2'), {x: 35, y: -30}),
                LeaderLine.pointAnchor(document.getElementById('opp-number-3'), {x: 20, y: -40}),
                options
            );

            new LeaderLine(
                LeaderLine.pointAnchor(document.getElementById('opp-number-3'), {x: 40, y: -30}),
                LeaderLine.pointAnchor(document.getElementById('opp-number-4'), {x: 40, y: -40}),
                options
            );
        }
    } ); // doOnEvent
}
